// extracted by mini-css-extract-plugin
export var media = "styles-module--media--5605d";
export var mediaCaption = "styles-module--mediaCaption--3ec78";
export var mediaContainer = "styles-module--mediaContainer--e96b3";
export var mediaCredit = "styles-module--mediaCredit--b418d";